import styled from "styled-components";

export const Wrapper = styled.div`
height: 60px;
width: 100%;
position: absolute;
bottom: 0;`